import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {RootState} from '../../../redux/store.type';
import * as css from './EndingContent.css';

function EndingContent() {
    const {t} = useTranslation('eTicket');
    const producer = useSelector((s: RootState) => s.eTicket.data?.producer);
    const live = useSelector((s: RootState) => s.eTicket.data?.live);

    return (
        <css.content data-cy="ticket-ending-content">
            <css.thanks>{t('thanksTitle')}</css.thanks>
            {(producer?.logo || producer?.packageName) && (
                <css.block>
                    <css.blockLabel>{t('producedBy')}</css.blockLabel>
                    {producer.logo
                        ? <css.producerLogo src={producer.logo} alt={producer.packageName} />
                        : <css.producerName>{producer.packageName}</css.producerName>}
                </css.block>
            )}
            {(live?.logo || !!live?.links?.length) && (
                <>
                    <css.sep aria-hidden />
                    <css.liveGroup>
                        {live.logo && <css.liveLogo src={live.logo} alt="Tickchak Live" />}
                        {!!live.links?.length && (
                            <css.pills>
                                {live.links.map(link => (
                                    <css.pill key={link.url} href={link.url} target="_blank" rel="noreferrer" data-cy={`ending-live-${link.type}`}>
                                        {link.image && <css.avatar src={link.image} alt="" />}
                                        <span>{link.title}</span>
                                    </css.pill>
                                ))}
                            </css.pills>
                        )}
                    </css.liveGroup>
                </>
            )}
        </css.content>
    );
}

export default EndingContent;
